//  Equalize Card Heading Heights code start
window.addEventListener("load", () => {
  const items = document.querySelectorAll(".product-card-wrapper .card__information-head");
  if (!items.length) return;
  let max = Math.max(...[...items].map(i => i.offsetHeight));
  items.forEach(i => i.style.minHeight = max + "px");
});
//  Equalize Card Heading Heights code end